import { TaxInvoiceType } from '~models/tax-invoice';

export type SettlementStatus = 'DELAYED' | 'SCHEDULED' | 'DONE';

export const getStautsForBadge = (
  status: SettlementStatus,
): {
  text: string;
  status: 'success' | 'warning' | 'error';
} => {
  switch (status) {
    case 'DELAYED':
      return {
        text: '지연',
        status: 'error',
      };
    case 'SCHEDULED':
      return {
        text: '예정',
        status: 'warning',
      };
    case 'DONE':
      return {
        text: '완료',
        status: 'success',
      };
  }
};

export const formatNumByTaxInvoice = (num: number, type: TaxInvoiceType) => {
  return (type === 'SALES' ? 1 : -1) * num;
};
